module.exports = __webpack_public_path__ + "img/IMG_20190403_134152.99ada136.jpg";